<template>
  <el-container  style="display: block;">
    <el-row  class="elementsz" style="margin-top: 30px;margin-left: 30px;">
      <el-row :span="2" style="margin-top: 30px;">
          输入关键词:<el-input v-model="name" style="width: 150px;" placeholder="请输入关键词"></el-input>
      </el-row>
      <el-row :span="2" style="margin-top: 30px;">
          名称:<el-input v-model="shuoming" style="width: 150px;" placeholder="请输入名称"></el-input>
      </el-row>
      <el-row :span="2" style="margin-top: 30px;">
          <el-select v-model="valuef" @change="fenzu()"  filterable placeholder="请选择" >
              <el-option
                v-for="item in optionf"
                :key="item.name"
                :label="item.name"

                :value="item.value">
              </el-option>
            </el-select>
      </el-row>
      <el-row :span="2" style="margin-top: 30px;">
          时间尺:<el-input v-model="timej" style="width: 150px;" placeholder="请输入时间间隔范围"></el-input>
      </el-row>
      <el-row :span="2" style="margin-top: 30px;">
          速率尺:<el-input v-model="su" style="width: 150px;" placeholder="请输入速率范围"></el-input>
      </el-row>
      <el-row :span="2" style="margin-top: 30px;">
          透视尺:<el-input v-model="tou" style="width: 150px;" placeholder="请输入透视"></el-input>
      </el-row>
      <el-row :span="2" style="margin-top: 30px;">
          层级尺:<el-input v-model="ceng" style="width: 150px;" placeholder="请输入层级"></el-input>
      </el-row>
      <el-row :span="2" style="margin-top: 30px;">
          缩放尺:<el-input v-model="bi" style="width: 150px;" placeholder="请输入比例"></el-input>
      </el-row>
      <el-row :span="2" style="margin-top: 30px;">
          <el-select v-model="jcs"  filterable placeholder="请选择" >
              <el-option
                v-for="item in jcss"
                :key="item.name"
                :label="item.name"

                :value="item.value">
              </el-option>
            </el-select>
      </el-row>
      <el-row :span="2" style="margin-top: 30px;">
          <el-select v-model="sx"  filterable placeholder="请选择" >
              <el-option
                v-for="item in sxs"
                :key="item.name"
                :label="item.name"

                :value="item.value">
              </el-option>
            </el-select>
      </el-row>
      <el-row :span="2" style="margin-top: 30px;">
          <el-select v-model="value"  filterable placeholder="请选择" >
              <el-option
                v-for="item in options"
                :key="item.name"
                :label="item.name"

                :value="item.value">
              </el-option>
            </el-select>
      </el-row>
      <el-row :span="2" style="margin-top: 30px;">
          <el-select v-model="valueg"  filterable placeholder="请选择" >
              <el-option
                v-for="item in optiong"
                :key="item.name"
                :label="item.name"

                :value="item.value">
              </el-option>
            </el-select>
      </el-row>
      <el-row :span="2" style="margin-top: 30px;">
          <el-select v-model="valuex"  filterable placeholder="请选择" >
              <el-option
                v-for="item in optionx"
                :key="item.name"
                :label="item.name"

                :value="item.value">
              </el-option>
            </el-select>
      </el-row>
      <el-row style="margin-top: 30px;width: 60%;">
        添加图片:<el-input v-model="addImage" style="width: 150px;" placeholder="请输入图片名称"></el-input>
        <el-button type="success" round @click="addImageCheck()">添加</el-button>
      </el-row>
      <el-row :span="2" style="margin-top: 30px;">
          <template>
            <el-table
          	:data="imgs"
            height="300"
          	border
          	style="width: 33%;margin-left: 0;height: 800px;text-align: center;">
          	<el-table-column
              prop="img1"
              width="79"
          	  label="正上"
          	   >
               <template slot-scope="scope">
                 <img  :src="scope.row.img1" class="avatar" style="width: 50px;height: 50px;">
               </template>
          	</el-table-column>
          	<el-table-column
          	  prop="img2"
          	  width="79"
          	  label="左上"
          	   >
               <template slot-scope="scope">
                 <img  :src="scope.row.img2" class="avatar" style="width: 50px;height: 50px;">
               </template>
          	</el-table-column>
             <el-table-column
               prop="img3"
               width="79"
               label="左侧"
                >
                <template slot-scope="scope">
                  <img  :src="scope.row.img3" class="avatar" style="width: 50px;height: 50px;">
                </template>
             </el-table-column>
             <el-table-column
               prop="img4"
               width="79"
               label="左下"
                >
                <template slot-scope="scope">
                  <img  :src="scope.row.img4" class="avatar" style="width: 50px;height: 50px;">
                </template>
             </el-table-column>
             <el-table-column
               prop="img5"
               width="79"
               label="正下"
                >
                <template slot-scope="scope">
                  <img  :src="scope.row.img5" class="avatar" style="width: 50px;height: 50px;">
                </template>
             </el-table-column>
             <el-table-column
               prop="img6"
               width="79"
               label="右下"
                >
                <template slot-scope="scope">
                  <img  :src="scope.row.img6" class="avatar" style="width: 50px;height: 50px;">
                </template>
             </el-table-column>
             <el-table-column
               prop="img7"
               width="78"
               label="右侧"
                >
                <template slot-scope="scope">
                  <img  :src="scope.row.img7" class="avatar" style="width: 50px;height: 50px;">
                </template>
             </el-table-column>
             <el-table-column
               prop="img8"
               width="78"
               label="右上"
                >
                <template slot-scope="scope">
                  <img  :src="scope.row.img8" class="avatar" style="width: 50px;height: 50px;">
                </template>
             </el-table-column>
             <el-table-column
               width="78"
               label="操作"
                >
                <template slot-scope="scope">
                  <i class="el-icon-delete" @click="delImgs(scope.$index)"></i>
                </template>
             </el-table-column>
            </el-table>
          </template>
      </el-row>
      <el-row :span="2" style="margin-top: 30px;">
         <el-col :span="3" >

           <el-time-select
             style="margin-bottom: -1px;margin-right: -21px;"
             v-model="time1"
             :picker-options="{
               start: '00:00',
               step: '00:01',
               end: '24:00'
             }"
             placeholder="选择开始时间">
           </el-time-select>
         </el-col>
         <el-col :span="3">
           <el-time-select
             v-model="time2"
             :picker-options="{
               start: '00:00',
               step: '00:01',
               end: '24:00'
             }"
             placeholder="选择结束时间">
           </el-time-select>
         </el-col>
         <el-col :span="2" style="text-align: center;">
           <el-input v-model="at" style="width: 150px;" placeholder="请输入百分比"></el-input>
         </el-col>
         <el-col :span="1" style="text-align: center;">
           <el-button type="primary" style="background-color: #409eff;" @click="addTime()" round>添加时段</el-button>
         </el-col>
      </el-row>

      <el-row :span="2" style="margin-top: 30px;">
          <template>
            <el-table
          	:data="times"
            height="300"
          	border
          	style="width: 25%;margin-left: 0;height: 800px;text-align: center;">
          	<el-table-column
              prop="time"
              width="200"
          	  label="时段"
          	   >

          	</el-table-column>
          	<el-table-column
              prop="bai"
              width="150"
          	  label="百分比"
          	   >
          	</el-table-column>

            <el-table-column
              width="180"
              label="操作"
               >
               <template slot-scope="scope">
                 <i class="el-icon-delete" @click="delTime(scope.$index)"></i>
               </template>
            </el-table-column>
            </el-table>
          </template>
      </el-row>
      <el-row :span="2" style="margin-top: 30px;">
          <el-button type="primary" style="background-color: #409eff;" @click="add()" round>添加</el-button>
      </el-row>
      <el-row :span="2" style="margin-top: 30px;">
          <el-input v-model="seachName" style="width: 150px;" placeholder="请输入搜索词"></el-input>
          <el-button type="primary" style="background-color: #409eff;" @click="seach()" round>搜索</el-button>
          <el-button round :class="{'pai':pait==1}" @click="pai(1)">开关排序</el-button>
          <el-button round :class="{'pai':pait==2}" @click="pai(2)">时间排序</el-button>
      </el-row>
    </el-row>
    <el-row  class="elementsz" style="margin-top: 30px;margin-left: 30px;">
      <template>
        <el-table
      	:data="tableData"
        height="1500"
      	border
      	style="width: 95%;margin-left: 0;height: 800px;text-align: center;">
        <el-table-column

          width="100"
          label="开关"
           >
           <template slot-scope="scope">
                <div style="color: greenyellow;"  @click="kg(2,scope.row.id)" v-if="scope.row.status == 1">开</div>
                <div style="color: red;"  @click="kg(1,scope.row.id)" v-if="scope.row.status == 2">关</div>
                <div style="color: blue;margin-top: 20px;"  @click="changeT(17,scope.row.bsc,scope.row.id)" >{{scope.row.bsc}}</div>

           </template>
        </el-table-column>
        <el-table-column

          width="180"
          label="名称"
           >
           <template slot-scope="scope">
               <div  @click="changeT(20,scope.row.shuoming,scope.row.id)">{{scope.row.shuoming}}</div>



           </template>
        </el-table-column>
      	<el-table-column

          width="180"
      	  label="关键词"

      	   >
            <template slot-scope="scope">
                <div  @click="changeT(1,scope.row.name,scope.row.id)">{{scope.row.name}}</div>
                <div  @click="copy(1,scope.row.id)" style="color: #409eff;margin-top: 20px;">(复制)</div>
            </template>
      	</el-table-column>
      	<!-- <el-table-column

          width="900"
      	  label="图片"
      	   >
           <template slot-scope="scope">
             <el-row v-for="(items,indexs) in scope.row.img" :key="indexs" style="margin-top: 20px;">
                <el-col :span="2" style="text-align: center;">
                  <el-button type="info" round>{{items.name}}</el-button>
                </el-col>
               <el-col :span="2" style="text-align: center;margin-left: 20px;margin-top: 7px;" @click.native="dischange(items.dis,items.id)" >
                 {{items.dis}}
               </el-col>
               <el-col :span="2" style="text-align: center;"><i class="el-icon-delete" style="position: absolute;margin-top: 12px;" @click="del(items.id)"></i></el-col>


             </el-row>
             <el-row>
             <el-button type="success" round @click="addNewImage(scope.row.id)" style="margin-top: 20px;">添加图片</el-button>
             </el-row>

           </template>
      	</el-table-column> -->
		<el-table-column

		  width="750"
		  label="图片"
		   >
		   <template slot-scope="scope">
		     <el-tooltip class="item" effect="dark" :content="scope.row.imggname" placement="right">
		     <div style="float: left;margin-right: 20px;margin-top: 10px;color: blue;" @click="seeImage(scope.row.id)">
		        查看图片分组
		     </div>
		     </el-tooltip>


		     <el-button type="success" round @click="addNewImage(scope.row.id)">添加图片</el-button>
		     <el-button type="success" round @click="addNewImages(scope.row.id)">添加组图</el-button>

		   </template>
		</el-table-column>
        <el-table-column

          width="200"
          label="时间段"
           >
           <template slot-scope="scope">
             <div style="color: blue;margin-bottom: 20px;"  @click="changeT(18,scope.row.zyc,scope.row.id)" >{{scope.row.zyc}}</div>
             <div  v-for="(items,indexs) in scope.row.time" :key="indexs" @click="ct(items.id,items.time,items.bai)">
               <div style="float: left;">{{items.time}} </div>
               <div style="float: left;">#{{items.bai}} </div>
               <div style="float: left;"><i class="el-icon-circle-close" style="margin-left: 10px;" @click="delEc(items.id)"></i></div>
             </div>
             <i v-if="scope.row.time.length == 0" style="margin-left: 30px;" @click="changeTime(scope.row.id)" class="el-icon-plus el-icon-circle-plus-outline"></i>
           </template>
        </el-table-column>
        <el-table-column

          width="100"
          label="透视"
           >
           <template slot-scope="scope">
               <div  @click="changeT(14,scope.row.tou,scope.row.id)">{{scope.row.tou}}</div>
           </template>
        </el-table-column>
        <el-table-column

          width="100"
          label="层级"
           >
           <template slot-scope="scope">
               <div  @click="changeT(15,scope.row.ceng,scope.row.id)">{{scope.row.ceng}}</div>
           </template>
        </el-table-column>
        <el-table-column

          width="100"
          label="分组"

           >
           <template slot-scope="scope">
               <div  @click="changeT(8,scope.row.zu,scope.row.id)">{{scope.row.zu}}</div>
           </template>
        </el-table-column>
        <el-table-column

          width="100"
          label="进/出"

           >
           <template slot-scope="scope">
               <div  @click="changeT(13,scope.row.jcs,scope.row.id)">{{scope.row.jcs}}</div>
           </template>
        </el-table-column>
        <el-table-column

          width="100"
          label="比例"

           >
           <template slot-scope="scope">
               <div  @click="changeT(11,scope.row.bi,scope.row.id)">{{scope.row.bi}}</div>
           </template>
        </el-table-column>
        <el-table-column

          width="100"
          label="星空粒子"

           >
           <template slot-scope="scope">
               <div  @click="changeT(12,scope.row.sx,scope.row.id)">{{scope.row.sx}}</div>
           </template>
        </el-table-column>
        <!-- <el-table-column

          width="100"
          label="多向"

           >
           <template slot-scope="scope">
               <div  @click="changeT(9,scope.row.xi,scope.row.id)">{{scope.row.xi}}</div>
           </template>
        </el-table-column> -->
        <el-table-column

          width="100"
          label="面判定"

           >
           <template slot-scope="scope">
               <div  @click="changeT(2,scope.row.tm,scope.row.id)">{{scope.row.tm}}</div>
           </template>
        </el-table-column>
        <el-table-column

          width="100"
          label="方向"
           >
           <template slot-scope="scope">
               <div  @click="changeT(7,scope.row.xi,scope.row.id)">{{scope.row.xi}}</div>
           </template>
        </el-table-column>
        <el-table-column

          width="100"
          label="轨迹"

           >
           <template slot-scope="scope">
               <div v-if="scope.row.gui"  @click="changeT(4,scope.row.gui,scope.row.id)">{{scope.row.gui}}</div>
               <div v-else  @click="changeT(4,scope.row.gui,scope.row.id)">修改</div>
           </template>
        </el-table-column>
        <el-table-column

          width="100"
          label="时间间隔范围"

           >
           <template slot-scope="scope">
               <div v-if="scope.row.timea"  @click="changeT(5,scope.row.timea,scope.row.id)">{{scope.row.timea}}</div>
               <div v-else  @click="changeT(5,scope.row.timea,scope.row.id)">修改</div>
           </template>
        </el-table-column>
        <el-table-column

          width="100"
          label="速率范围"

           >
           <template slot-scope="scope">
               <div v-if="scope.row.su"  @click="changeT(6,scope.row.su,scope.row.id)">{{scope.row.su}}</div>
               <div v-else  @click="changeT(6,scope.row.su,scope.row.id)">修改</div>
           </template>
        </el-table-column>
        <el-table-column

          width="80"
          label="操作"
           >
           <template slot-scope="scope">
             <i class="el-icon-delete" @click="delAll(scope.row.id)"></i>
           </template>






        </el-table-column>
        </el-table>

      </template>
      <div class="page">
      	<el-pagination
      	  @size-change="loadData()"
      	  @current-change="loadData()"
      	  :current-page.sync="page"
      	  :page-size="20"
      	  background
      	  layout="total,prev, pager, next, jumper"
      	  :total="count">
      	</el-pagination>
      </div>
    </el-row>
    <el-dialog
      title="添加"
      :visible.sync="timeVisible"
      width="30%"
      center>
      <input type="text" class="searchT" v-model="timesadd"/>
      <span slot="footer" class="dialog-footer">
    	<el-button style="margin-top: 10px;" @click="timeVisible = false">取 消</el-button>
    	<el-button style="margin-top: 10px;" type="primary" @click="doEc()">确 定</el-button>
      </span>
    </el-dialog>
    <el-dialog
      title="修改"
      :visible.sync="centerDialogVisible"
      width="30%"
      center>
      <input type="text" class="searchT" v-model="changes"/>
      <span slot="footer" class="dialog-footer">
    	<el-button @click="centerDialogVisible = false">取 消</el-button>
    	<el-button type="primary" @click="doChange()">确 定</el-button>
      </span>
    </el-dialog>
    <el-dialog
      title="修改时间段"
      :visible.sync="ctDialogVisible"
      width="30%"
      center>
      <input type="text" class="searchT" v-model="ct_time"/>
      <span slot="footer" class="dialog-footer">
    	<el-button @click="ctDialogVisible = false">取 消</el-button>
    	<el-button type="primary" @click="doCt()">确 定</el-button>
      </span>
    </el-dialog>
    <el-dialog
      title="提示"
      :visible.sync="dialogVisibled"
      width="30%"
      >
      <span>确认删除？</span>
      <span slot="footer" class="dialog-footer">
    	<el-button @click="dialogVisibled = false">取 消</el-button>
    	<el-button type="primary" @click="doDell()">确 定</el-button>
      </span>
    </el-dialog>
    <el-dialog
      title="提示"
      :visible.sync="dialogVisibleds"
      width="30%"
      >
      <span>确认删除整组图片？</span>
      <span slot="footer" class="dialog-footer">
    	<el-button @click="dialogVisibleds = false">取 消</el-button>
    	<el-button type="primary" @click="doDells()">确 定</el-button>
      </span>
    </el-dialog>
    <el-dialog
      title="高度尺"
      :visible.sync="disDialogVisible"
      width="30%"
      center>
      <input type="text" class="searchT" v-model="disName"/>
      <span slot="footer" class="dialog-footer">
    	<el-button @click="disDialogVisible = false">取 消</el-button>
    	<el-button type="primary" @click="dodisChange()">确 定</el-button>
      </span>
    </el-dialog>
    <el-dialog
      title="添加图片"
      :visible.sync="imgVisible"
      width="30%"
      center>
      <input type="text" class="searchT" v-model="imgName"/>
      <span slot="footer" class="dialog-footer">
    	<el-button @click="imgVisible = false">取 消</el-button>
    	<el-button type="primary" @click="doAddImg()">确 定</el-button>
      </span>
    </el-dialog>
    <el-dialog
      title="添加图片组"
      :visible.sync="imgVisibleG"
      width="30%"
      center>
      <input type="text" class="searchT" v-model="imgNameG"/>
      <span slot="footer" class="dialog-footer">
    	<el-button @click="imgVisibleG = false">取 消</el-button>
    	<el-button type="primary" @click="doAddImgG()">确 定</el-button>
      </span>
    </el-dialog>
    <el-dialog
          title="查看图片"
          :visible.sync="seeimgVisiblec"
          width="50%"
          center>
          <el-row  style="margin-top: 30px;" v-for="(items,indexs) in seeimgs">
              <div style="text-align: center;float: left;margin-top: 10px;">
                {{items.name}}
              </div>
              <div style="text-align: center;float: left;margin-top: 10px;color: red;margin-left: 20px;" @click="dels(items.value[0].id)">
                组删除
              </div>
              <div  style="text-align: center;float: left;margin-left: 30px;" v-for="(item,index) in items.value">
                <div>
                  {{item.name}}
                  <i class="el-icon-circle-close" style="position: absolute;margin-left: 5px;" @click="del(item.id)"></i>
                </div>
                <!-- <div style="margin-top: 10px;">
                  <img  :src="item.img1" class="img-content" style="width: 100px;height: 100px;">
                  <img  :src="item.img2" class="img-content" style="width: 100px;height: 100px;">
                  <img  :src="item.img3" class="img-content" style="width: 100px;height: 100px;">
                  <img  :src="item.img4" class="img-content" style="width: 100px;height: 100px;">
                  <img  :src="item.img5" class="img-content" style="width: 100px;height: 100px;">
                  <img  :src="item.img6" class="img-content" style="width: 100px;height: 100px;">
                  <img  :src="item.img7" class="img-content" style="width: 100px;height: 100px;">
                  <img  :src="item.img8" class="img-content" style="width: 100px;height: 100px;">
                  <i class="el-icon-circle-close" style="position: absolute;margin-left: 5px;margin-top: 15px;" @click="del(item.id)"></i>
                </div> -->
              </div>
          </el-row>
          </span>
        </el-dialog>
  </el-container>

</template>

<script>

  export default {
    data() {
       return {
         page:1,
         count:0,
         dialogImageUrl: '',
         dialogVisible: false,
         tableData:[],
         imageList:[],
         name:'',
         dialogVisibled:false,
         delId:0,
         options:[{'name':'1面','value':'1面'},{'name':'2面','value':'2面'},{'name':'3面','value':'3面'},{'name':'4面','value':'4面'}],
         value:'2面',
         optionx:[{'name':'4向','value':'4向'},{'name':'8向','value':'8向'}],
         valuex:'4向',
         changes:'',
         centerDialogVisible:false,
         t:1,
         c_id:0,
         dz:'0-0',
         tm:'0',
         time1:'',
         time2:'',
         at:100,
         times:[],
         timeStr:'',
         timeVisible:false,
         timec1:'',
         timec2:'',
         atc:100,
         timesc:[],
         timeStrc:'',
         ec_id:0,
         optiong:[{'name':'折线','value':'折线'}],
         valueg:'折线',
         su:'0-0',
         timej:'0-0',
         img1:'',
         img2:'',
         img3:'',
         img4:'',
         img5:'',
         img6:'',
         img7:'',
         img8:'',
         imgs:[],
         ct_id:0,
         ct_time:'',
         ctDialogVisible:false,
         optionf:[{'name':'不分组','value':'不分组'},{'name':'组1','value':'组1'},{'name':'组2','value':'组2'},{'name':'组3','value':'组3'},{'name':'组4','value':'组4'},{'name':'组5','value':'组5'},{'name':'组6','value':'组6'},{'name':'组7','value':'组7'},{'name':'组8','value':'组8'},{'name':'组9','value':'组9'},{'name':'组10','value':'组10'}],
         valuef:'不分组',
         bi:'100',
         sx:'上',
         sxs:[{'name':'上','value':'上'},{'name':'下','value':'下'}],
         jcs:'双向',
         jcss:[{'name':'进','value':'进'},{'name':'出','value':'出'},{'name':'双向','value':'双向'}],
         disDialogVisible:false,
         changeDis:'',
         disId:0,
         disName:'',
         tou:'100',
         ceng:'0',
         addImage:'',
         imgVisible:false,
         imgName:'',
         imgId:0,
         tlc:'否',
         bsc:'100',
         zyc:'否',
         seachName:'',
         timesadd:'',
         pait:1,
         seeimgVisiblec:false,
         seeimgs:[],
         imgVisibleG:false,
         imgNameG:'',
         dialogVisibleds:false,
         shuoming:'未定义名称'
      }
    },
	directives: {
    },
    created() {
      if(!window.localStorage.getItem('id')){
        this.$router.push({ path: '/' })
      }
      this.loadData();
      var lett = this;
       document.onkeydown = function(e) {
       var key = window.event.keyCode;
       if (key == 13) {
         lett.seach();
       }
      }
    },

	methods:{
    seeImage(id){
      const axiosInstance = this.$axios.create({
      	headers: {'Content-Type': 'application/json;charset=utf-8'},// 设置传输内容的类型和编码
      	withCredentials: true,// 指定某个请求应该发送凭据。允许客户端携带跨域cookie，也需要此配置
      });


      axiosInstance({
      	method:'post',
      	params:{
      		id:id,
          t:1
      	},
      	url:'http://y31p.yoooooo.com/index.php/index/data/elementsListSees'
      })
      .then(res=>{
        this.seeimgVisiblec = true;
      	this.seeimgs = res.data.list;

      })
      .catch(err=>{

      });
    },
    addNewImages(id){
      this.imgId = id;
      this.imgVisibleG = true;
    },
    doAddImgG(){
      const axiosInstance = this.$axios.create({
      	headers: {'Content-Type': 'application/json;charset=utf-8'},// 设置传输内容的类型和编码
      	withCredentials: true,// 指定某个请求应该发送凭据。允许客户端携带跨域cookie，也需要此配置
      });
      axiosInstance({
      	method:'post',
      	params:{
          name:this.imgNameG,
          id:this.imgId,
          t:1

      	},
      	url:'http://y31p.yoooooo.com/index.php/index/data/pythonImgSaveMoreNewsg'
      })
      .then(res=>{
         if(res.data.code == 200){
            this.loadData();

            this.imgVisibleG = false;
         }else{

           this.$message({
           	type: 'error',
           	message: '图片不存在'
           });
         }

         // this.addImage = ''

      })
      .catch(err=>{

      });
    },
    pai(t){
      this.pait = t;
      this.p = 1;
      this.loadData();
    },
    seach(){
      this.loadData();
    },
    doAddImg(){
      const axiosInstance = this.$axios.create({
      	headers: {'Content-Type': 'application/json;charset=utf-8'},// 设置传输内容的类型和编码
      	withCredentials: true,// 指定某个请求应该发送凭据。允许客户端携带跨域cookie，也需要此配置
      });
      axiosInstance({
      	method:'post',
      	params:{
          name:this.imgName,
          id:this.imgId,
          t:1

      	},
      	url:'http://y31p.yoooooo.com/index.php/index/data/pythonImgSaveMoreNewsg'
      })
      .then(res=>{
         if(res.data.code == 200){
            this.loadData();

            this.imgVisible = false;
         }else{

           this.$message({
           	type: 'error',
           	message: '图片不存在'
           });
         }

         // this.addImage = ''

      })
      .catch(err=>{

      });
    },
    addNewImage(id){
      this.imgId = id;
      this.imgVisible = true;
    },
    addImageCheck(){
      const axiosInstance = this.$axios.create({
      	headers: {'Content-Type': 'application/json;charset=utf-8'},// 设置传输内容的类型和编码
      	withCredentials: true,// 指定某个请求应该发送凭据。允许客户端携带跨域cookie，也需要此配置
      });
      axiosInstance({
      	method:'post',
      	params:{
          name:this.addImage,

      	},
      	url:'http://y31p.yoooooo.com/index.php/index/data/addImageChecks'
      })
      .then(res=>{
         if(res.data.code == 200){
            this.imgs.push(res.data.data)
         }else{
           this.$message({
           	type: 'error',
           	message: '图片不存在'
           });
         }

         // this.addImage = ''

      })
      .catch(err=>{

      });
    },
    copy(t,id){
      const axiosInstance = this.$axios.create({
      	headers: {'Content-Type': 'application/json;charset=utf-8'},// 设置传输内容的类型和编码
      	withCredentials: true,// 指定某个请求应该发送凭据。允许客户端携带跨域cookie，也需要此配置
      });
      axiosInstance({
      	method:'post',
      	params:{
          id:id,
          t:t
      	},
      	url:'http://y31p.yoooooo.com/index.php/index/data/pythonCopys'
      })
      .then(res=>{
        this.$message({
        	type: 'sucsess',
        	message: '复制成功'
        });
         this.loadData()

      })
      .catch(err=>{

      });
    },
    UploadUrladd(id){
       return "http://y31p.yoooooo.com/index.php/index/data/pythonImgChangeAdd?t=1&id="+id
    },
    UploadUrls(id,n){
       return "http://y31p.yoooooo.com/index.php/index/data/pythonImgChanges?t="+n+"&id="+id
    },
    dischange(name,id){
      this.disId = id
      this.disName = name
      this.disDialogVisible = true
    },
    dodisChange(){
      const axiosInstance = this.$axios.create({
      	headers: {'Content-Type': 'application/json;charset=utf-8'},// 设置传输内容的类型和编码
      	withCredentials: true,// 指定某个请求应该发送凭据。允许客户端携带跨域cookie，也需要此配置
      });
      axiosInstance({
      	method:'post',
      	params:{
          id:this.disId,
          t:1,
          name:this.disName,
      	},
      	url:'http://y31p.yoooooo.com/index.php/index/data/elementDisChanges'
      })
      .then(res=>{
         this.disDialogVisible = false
         this.loadData()

      })
      .catch(err=>{

      });
    },
    kg(p,id){
      const axiosInstance = this.$axios.create({
      	headers: {'Content-Type': 'application/json;charset=utf-8'},// 设置传输内容的类型和编码
      	withCredentials: true,// 指定某个请求应该发送凭据。允许客户端携带跨域cookie，也需要此配置
      });
      axiosInstance({
      	method:'post',
      	params:{
          id:id,
          p:p,
          t:1
      	},
      	url:'http://y31p.yoooooo.com/index.php/index/data/statusChange'
      })
      .then(res=>{
         this.loadData()

      })
      .catch(err=>{

      });
    },
    fenzu(){
      if(this.valuef!='不分组'){
        this.tableData.forEach(item =>{
          if(item.name == this.name && item.zu == this.valuef){
            console.log(item)
            this.timej = item.timea
            this.su = item.su
            this.value = item.tm
            this.valueg = item.gui
            this.times = []
            console.log(item.time)
            item.time.forEach(val=>{
              this.times.push({'time':val.time,'bai':val.bai})
            })
            this.zuTime()

          }

        })
      }

    },
    ct(id,time,bai){
      this.ct_id = id
      this.ct_time = time+'#'+bai
      this.ctDialogVisible = true
    },
    doCt(){
      const axiosInstance = this.$axios.create({
      	headers: {'Content-Type': 'application/json;charset=utf-8'},// 设置传输内容的类型和编码
      	withCredentials: true,// 指定某个请求应该发送凭据。允许客户端携带跨域cookie，也需要此配置
      });
      axiosInstance({
      	method:'post',
      	params:{
          id:this.ct_id,
          time:this.ct_time
      	},
      	url:'http://y31p.yoooooo.com/index.php/index/data/timesChange'
      })
      .then(res=>{
         this.ctDialogVisible = false
         this.ct_id = 0
         this.ct_time = ''
         this.loadData()

      })
      .catch(err=>{

      });
    },
    delImgs(index){
      this.imgs.splice(index,1);
    },
    addImg(){
      this.imgs.push({'img1':this.img1,'img2':this.img2,'img3':this.img3,'img4':this.img4,'img5':this.img5,'img6':this.img6,'img7':this.img7,'img8':this.img8})

    },
    handleAvatarSuccess1(res, file){
      this.img1 = file.response.data;
    },
    handleAvatarSuccess2(res, file){
      this.img2 = file.response.data;
    },
    handleAvatarSuccess3(res, file){
      this.img3 = file.response.data;
    },
    handleAvatarSuccess4(res, file){
      this.img4 = file.response.data;
    },
    handleAvatarSuccess5(res, file){
      this.img5 = file.response.data;
    },
    handleAvatarSuccess6(res, file){
      this.img6 = file.response.data;
    },
    handleAvatarSuccess7(res, file){
      this.img7 = file.response.data;
    },
    handleAvatarSuccess8(res, file){
      this.img8 = file.response.data;
    },
    handleAvatarSuccessch(res, file) {
      this.loadData();
      // this.imageList.push(file.response.data)
    },
    handleAvatarSuccessadd(res, file) {
      this.loadData();
      // this.imageList.push(file.response.data)
    },
    changeTime(id){
      this.ec_id = id
      this.timeVisible = true
    },
    addTime(){
      this.times.push({'time':this.time1+'-'+this.time2,'bai':this.at})
      this.zuTime()
    },
    delTime(index){
      this.times.splice(index,1);
      this.zuTime()
    },
    zuTime(){
      let a = []
      this.times.forEach(function(item,index){
        a.push(item.time+'#'+item.bai)
      })
      this.timeStr = a.join(',')
    },
    addTimec(){
      this.timesc.push({'time':this.timec1+'-'+this.timec2,'bai':this.atc})
      this.zuTimec()
    },
    delTimec(index){
      this.timesc.splice(index,1);
      this.zuTimec()
    },
    zuTimec(){
      let a = []
      this.timesc.forEach(function(item,index){
        a.push(item.time+'#'+item.bai)
      })
      this.timeStrc = a.join(',')
    },
    doEc(){
      const axiosInstance = this.$axios.create({
      	headers: {'Content-Type': 'application/json;charset=utf-8'},// 设置传输内容的类型和编码
      	withCredentials: true,// 指定某个请求应该发送凭据。允许客户端携带跨域cookie，也需要此配置
      });
      axiosInstance({
      	method:'post',
      	params:{
          id:this.ec_id,
          type:1,
          time:this.timesadd
      	},
      	url:'http://y31p.yoooooo.com/index.php/index/data/elementszDoec'
      })
      .then(res=>{
         this.timeVisible = false
         this.timeStrc = ''
         this.timesc = []
         this.ec_id = 0

         this.loadData()

      })
      .catch(err=>{

      });
    },
    delEc(id){
      const axiosInstance = this.$axios.create({
      	headers: {'Content-Type': 'application/json;charset=utf-8'},// 设置传输内容的类型和编码
      	withCredentials: true,// 指定某个请求应该发送凭据。允许客户端携带跨域cookie，也需要此配置
      });
      axiosInstance({
      	method:'post',
      	params:{
          id:id,

      	},
      	url:'http://y31p.yoooooo.com/index.php/index/data/elementszDelec'
      })
      .then(res=>{

         this.loadData()

      })
      .catch(err=>{

      });
    },
    changeT(t,n,id){
      this.c_id = id
      this.t = t
      this.changes = n
      this.centerDialogVisible = true
    },
    doChange(){
      const axiosInstance = this.$axios.create({
      	headers: {'Content-Type': 'application/json;charset=utf-8'},// 设置传输内容的类型和编码
      	withCredentials: true,// 指定某个请求应该发送凭据。允许客户端携带跨域cookie，也需要此配置
      });
      axiosInstance({
      	method:'post',
      	params:{
          id:this.c_id,
          t:this.t,
          n:this.changes
      	},
      	url:'http://y31p.yoooooo.com/index.php/index/data/elementszChange'
      })
      .then(res=>{
         this.centerDialogVisible = false
         this.c_id = 0
         this.t = ''
         this.changes = ''
         this.loadData()

      })
      .catch(err=>{

      });
    },
    clearFiles(){
      this.$refs['my-upload'].clearFiles();
    },
    handleRemove(file, fileList) {

      this.imageList = []
      fileList.forEach((item)=>{
        this.imageList.push(item.response.data)
      })
    },
    handlePictureCardPreview(file) {
      this.dialogImageUrl = file.url;
      this.dialogVisible = true;
    },
    handleAvatarSuccess(res, file) {
      this.imageList.push(file.response.data)
    },
    delAll(id){
      this.type = 1
      this.delId = id
      this.dialogVisibled = true
    },
    dels(id){
      this.type = 2
      this.delId = id
      this.dialogVisibleds = true
    },
    del(id){
      this.type = 2
      this.delId = id
      this.dialogVisibled = true
    },
    doDell(){

      const axiosInstance = this.$axios.create({
      	headers: {'Content-Type': 'application/json;charset=utf-8'},// 设置传输内容的类型和编码
      	withCredentials: true,// 指定某个请求应该发送凭据。允许客户端携带跨域cookie，也需要此配置
      });
      axiosInstance({
      	method:'post',
      	params:{
          id:this.delId,
          type:this.type
      	},
      	url:'http://y31p.yoooooo.com/index.php/index/data/elementszsDel'
      })
      .then(res=>{
         this.dialogVisibled = false
         this.loadData()

      })
      .catch(err=>{

      });
    },
    doDells(){

      const axiosInstance = this.$axios.create({
      	headers: {'Content-Type': 'application/json;charset=utf-8'},// 设置传输内容的类型和编码
      	withCredentials: true,// 指定某个请求应该发送凭据。允许客户端携带跨域cookie，也需要此配置
      });
      axiosInstance({
      	method:'post',
      	params:{
          id:this.delId,
          type:this.type
      	},
      	url:'http://y31p.yoooooo.com/index.php/index/data/elementduotuDels'
      })
      .then(res=>{
         this.dialogVisibleds = false
         this.loadData()

      })
      .catch(err=>{

      });
    },
    add(){

      if(this.imgs.length == 0){
        this.$message({
        	type: 'error',
        	message: '请选择图片'
        });
        return false
      }
      var a =[]
      for(var i=0;i<this.imgs.length;i++){
        a.push(JSON.stringify(this.imgs[i]))
      }
      if(this.tm.length == 0){
        this.$message({
        	type: 'error',
        	message: '请填写信息'
        });
        return false
      }
      if(this.dz.length == 0){
        this.$message({
        	type: 'error',
        	message: '请填写信息'
        });
        return false
      }
      // if(this.timeStr.length == 0){
      //   this.$message({
      //   	type: 'error',
      //   	message: '请填写时段信息'
      //   });
      //   return false
      // }
      const axiosInstance = this.$axios.create({
      	headers: {'Content-Type': 'application/json;charset=utf-8'},// 设置传输内容的类型和编码
      	withCredentials: true,// 指定某个请求应该发送凭据。允许客户端携带跨域cookie，也需要此配置
      });
      axiosInstance({
      	method:'post',
      	params:{
          name:this.name,
          type:2,
          tm:this.value,
          dz:this.dz,
          su:this.su,
          timej:this.timej,
          valueg:this.valueg,
          img:JSON.stringify(this.imgs),
          time:this.timeStr,
          xiang:this.valuex,
          zu:this.valuef,
          bi:this.bi,
          sx:this.sx,
          jcs:this.jcs,
          tou:this.tou,
          ceng:this.ceng,
          tlc:this.tlc,
          bsc:this.bsc,
          zyc:this.zyc,
          shuoming:this.shuoming
      	},
      	url:'http://y31p.yoooooo.com/index.php/index/data/elementszAdds'
      })
      .then(res=>{
         this.loadData()
         this.name = ''
         this.imgs = []
         this.img1 = ''
         this.img2 = ''
         this.img3 = ''
         this.img4 = ''
         this.img5 = ''
         this.img6 = ''
         this.img7 = ''
         this.img8 = ''
         this.timeStr = ''
         this.times = []
         this.clearFiles()
      })
      .catch(err=>{

      });
    },
    loadData(){
    	const axiosInstance = this.$axios.create({
    		headers: {'Content-Type': 'application/json;charset=utf-8'},// 设置传输内容的类型和编码
    		withCredentials: true,// 指定某个请求应该发送凭据。允许客户端携带跨域cookie，也需要此配置
    	});
    	axiosInstance({
    		method:'get',
    		params:{
          t:this.pait,
          p:this.page,
          name:this.seachName,
          type:2,
    		},
    		url:'http://y31p.yoooooo.com/index.php/index/data/elementszListsNew'
    	})
    	.then(res=>{
        this.seeimgVisiblec = false;
    		this.tableData = res.data.list;
        this.count = res.data.count;
    	})
    	.catch(err=>{

    	});
    },
    msg(msg,type){
    	this.$message({
    	  message: msg,
    	  type: type
    	});
    },

	}


  }
</script>

<style>
  .pai{
    background-color:rgb(64, 158, 255);
  }
</style>



// WEBPACK FOOTER //
// src/components/main/elementzxs.vue